<template>
  <div class="home_root flexV">
    <div
      v-if="chatDialog"
      class="mask"
    />
    <ymt-header v-if="!isShowHeader"/>
    <div class="flex1 flex over_hidden">
      <ymt-menu />
      <div
        :class="{padding20: (uiMode == 'pc_only' && !isShowHeader)}"
        class="flex1 flexV over_auto"
      >
        <chat v-if="chatDialog" />
        <Breadcrumb v-if="uiMode != 'pc_only' && !hideBreadcrumb" />
        <router-view class="flex1" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import chat from '@/views/chat'
import { mapGetters, mapState } from 'vuex'
import { helper } from '@ymt/gfw-axios'
import { MessageBox } from 'element-ui'
import { home } from '@/api'
export default {
  components: {
    Breadcrumb,
    chat
  },
  props: ['hideBreadcrumb'],
  data() {
    return {
      uiMode: window.uiMode
    }
  },
  computed: {
    ...mapGetters({
      menuHistory: 'authorizedHistory',
      isShowHeader:'isVideoManagementPage'
    }),
    ...mapState({
      chatDialog: state => state.chatDialog
    }),
  },
  methods: {
    // 退出
    logout() {
      MessageBox.confirm('确定退出登录?', '', {
        showCancelButton: true
      })
        .then(action => {
          home.logout().then(({ data }) => {
            if (data.status === 0) {
              helper.clearSid()
              this.$router.push({ name: 'login' })
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/lib.less";
.home_root {
  height: 100%;
  background-color: #f2f2f2;
}
.body {
  overflow: hidden;
}
.relative {
  position: relative;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
</style>
